import BotResponseTreeNode from './BotResponseTreeNode';
import MessageBlockContent from './MessageBlockContent';

class MessageBlockTreeNode {
  messageBlocks: MessageBlockContent[];

  nextStep: BotResponseTreeNode | null;

  category: string | null;

  responseCardsXPosition?: number;

  responseCardsYPosition?: number;

  constructor(
    messageBlocks: MessageBlockContent[],
    nextStep: BotResponseTreeNode | null,
    category: string | null,
    responseCardsXPosition?: number,
    responseCardsYPosition?: number
  ) {
    this.messageBlocks = messageBlocks;
    this.nextStep = nextStep;
    this.category = category;
    this.responseCardsXPosition = responseCardsXPosition;
    this.responseCardsYPosition = responseCardsYPosition;
  }
}

export default MessageBlockTreeNode;
